/** Coarse OS bucket used for download links / keyboard-hint display. */
export type OsType = 'apple' | 'windows' | 'mobile' | null;

/**
 * Returns OS identifier
 * @returns OS type ('mobile' covers iOS, Android and Linux; null when undetected)
 */
export function getOs(): OsType {
  var userAgent = window.navigator.userAgent,
    platform = window.navigator.platform,
    macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
    windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
    iosPlatforms = ['iPhone', 'iPad', 'iPod'],
    os: OsType = null;

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'apple';
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'mobile';
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'windows';
  } else if (/Android/.test(userAgent)) {
    os = 'mobile';
  } else if (!os && /Linux/.test(platform)) {
    os = 'mobile';
  }

  return os;
}

export default {
  getOs,
};
